import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { AllocationStatus, Escalation, downloadEscalation } from "../../Services/api";
import instance from "../../redux/api";
import { CommonButton } from "../common/commonButton";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TableContainer,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import { toast } from "react-toastify";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { ViewAndEditEntity } from "./ViewAndEditEntity";
import { AddEscalation } from "./AddEscalation";
import { getUsersList } from "../../redux/slice/usersListSlice";
import format from "date-fns/format";
import { commonToast } from "../common";
import { customDateFormat } from "../CashAllocation/utils";

// #region Styles
const AssignBankStatementBar = {
  display: "flex",
  justifyContent: "space-between",
  height: 32,
  fontWeight: "400",
  marginTop: 10,
};

const editEntityUpdate = {
  width: "90px",
  padding: "18px 0px",
  borderRadius: "20px",
  gap: "8px",
};

const bankTransactionAddBtn = {
  background: "#FF5A01",
  marginLeft: "5%",
  color: "white",
  borderRadius: "10px",
  padding: "5px 20px",
};

const ResetSubmit = {
  justifyContent: "flex-end",
  paddingTop: "0px",
  marginRight: "12px",
};

const addBankTransactionReset = {
  backgroundColor: "white",
  width: "90px",
  padding: "16px 0px",
  borderRadius: "20px",
  gap: "8px",
  color: "black",
  border: "1px solid black",
};

const EditPageContainerTransactions = {
  padding: "10px",
  cursor: "default",
  width: "100%",
  marginLeft: "-10px",
};

const CloseIconStyle = {
  backgroundColor: "#3B3F44",
  color: "#ffff",
  height: "16px",
  width: "16px",
  padding: "7px 8px",
  borderRadius: "32px",
};

const addBankTransactionSubmit = {
  backgroundColor: "#FF5A01",
  width: "90px",
  padding: "17px 0px",
  borderRadius: "13px",
  gap: "8px",
  color: "white",
};

const dialogStyle = {
  maxWidth: "90vw",
  width: "90vw",
  margin: "auto",
};

const downloadBtn = {
  background: "#FF5A01",
  marginLeft: "5%",
  color: "white",
  borderRadius: "10px",
  padding: "5px 25px !important",
  whiteSpace: "nowrap"
};

// #endregion

export default function EscalationContainer() {
  // Selectors
  const { usersList } = useSelector((state) => state?.usersList);
  const toggle = useSelector((state) => state.toggleSideMenu);
  const { userData } = useSelector((state) => state?.user);
  const [row, setRow] = useState([
    {
      organization: "",
      transaction_type: "",
      status: "",
      escalation_level_one: "",
      escalation_level_two: "",
      escalation_level_three: "",
    },
  ]);
  const [tableRows, setTableRows] = useState([]);
  const [isApiCallInprogress, setIsApiCallInprogress] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [escalationDialog, setEscalationDialog] = useState(false);
  const [editRow, setEditRow] = useState("");
  const [viewMode, setViewMode] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [isCreated, setIsCreated] = useState(true);
  const [editId, setEditId] = useState("");
  const [pageSize, setPageSize] = useState(5);
  const [page, setPage] = useState(0);
  const [currentUpdatedFiledsInEditMode, setCurrentUpdatedFiledsInEditMode] =
    useState({});

  const [validationStatus, setValidationStatus] = useState(true);
  const [statuses, setStatuses] = useState([]);
  const [cashAllocationStatuses, setCashAllocationStatuses] = useState([]);
  const [isDownloadInProgress, setIsDownloadInProgress] = useState(false);
  // const [allocationStatuses, setAllocationStatuses]= useState([])
  const [isDisable, setIsDisable] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getUsersList());
  }, []);

  const Container = {
    width: toggle?.isOpen ? "calc(100vw - 305px)" : "calc(100vw - 100px)",
    display: "flex",
    flexDirection: "column",
    gap: 8,
  };
  const bankTransactionStatuses = ["Open", "In Progress"];
  useEffect(() => {
    getCashAllocationStatuses();
  }, []);

  const getCashAllocationStatuses = async () => {
    const response = await instance.get(AllocationStatus);
    setCashAllocationStatuses(
      response.data.map((item) => item.allocation_status)
    );
  };

  const handleDialogClose = () => {
    setEscalationDialog(false);
    setEditMode(false);
    setViewMode(false);
    setStatuses([]);
    if (!editMode && !viewMode) {
      setRow(
        {
          organization: "",
          transaction_type: "",
          status: "",
          escalation_level_one: "",
          escalation_level_two: "",
          escalation_level_three: "",
        },
      );
      setValidationStatus(true);
    }

    else if (editMode) {
      setValidationStatus(true);
      setCurrentUpdatedFiledsInEditMode({});
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchText(value);
    let filteredData;
    if (value.trim() === "") {
      loadData();
      filteredData = tableRows;
    } else {
      filteredData = tableRows.filter((row) =>
        columns.some((column) => {
          const cellValue = row[column.field];
          if (Array.isArray(cellValue)) {
            // Check if the array is not null
            if (cellValue !== null && cellValue !== undefined) {
              // Check if any property within the objects in the array includes the search value
              return cellValue.some((item) =>
                Object.values(item).some(
                  (propValue) =>
                    propValue !== undefined &&
                    propValue !== null &&
                    propValue.toString().includes(value)
                )
              );
            }
          } else if (cellValue !== undefined && cellValue !== null) {
            // For non-array fields, continue with the existing logic
            return cellValue.toString().includes(value);
          }
          return false;
        })
      );
    }
    setTableRows(filteredData);
  };

  const handleActionButton = (rowData, isEditMode) => {
    const emptyRow = {
      organization: "",
      transaction_type: "",
      status: "",
      escalation_level_one: "",
      escalation_level_two: "",
      escalation_level_three: "",
    };

    if (rowData && isEditMode) {
      // Pre-fill the empty row with data for editing
      setRow({ ...rowData });
      setEditRow(rowData);
      setEditMode(true);
      setEditId(rowData.id);
      setIsCreated(false);

      if (rowData.transaction_type === "Bank Transaction") {
        setStatuses(bankTransactionStatuses);
      } else {
        setStatuses(cashAllocationStatuses);
      }
    } else if (rowData && !isEditMode) {
      setRow(rowData);
      setViewMode(true);
    } else {
      // If no rowDataForEdit is provided, it means we are in add mode
      setRow(emptyRow);
      setIsCreated(true);
      setEscalationDialog(true);
    }
    setEscalationDialog(true);
    if (rowData) {
      setIsCreated(false);
    } else {
      setIsCreated(true);
    }
  };

  const handleReset = () => {
    const emptyRow = {
      organization: "",
      transaction_type: "",
      status: "",
      escalation_level_one: "",
      escalation_level_two: "",
      escalation_level_three: "",
    };
    setRow(emptyRow);
    setValidationStatus(true);
  };

  // Handler for Escalation user Dropdown
  const handleEscalationUserChange = (name, value, reason) => {
    if (reason === "clear") {
      setRow({
        ...row,
        [name]: "",
      });
      if (editMode) {
        setCurrentUpdatedFiledsInEditMode({
          ...currentUpdatedFiledsInEditMode,
          [name]: "",
        });
      }
    } else {
      setRow({
        ...row,
        [name]: value,
      });
      
      if (editMode) {
        setCurrentUpdatedFiledsInEditMode({
          ...currentUpdatedFiledsInEditMode,
          [name]: value.id,
        });
      }
    }
  };

  const columns = [
    { field: "id", headerName: "ID", flex: 0.3, headerAlign: "center" },
    {
      field: "transaction_type",
      headerName: "Transaction Type",
      flex: 1,
      headerAlign: "center",
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      headerAlign: "center",
    },
    {
      field: "organization",
      headerName: "Organization",
      flex: 1,
      headerAlign: "center",
    },
    {
      field: "escalation_level_one",
      headerName: "Escalation-1",
      flex: 1,
      headerAlign: "center",
      valueGetter: (params) => params.value.user_name,
    },
    {
      field: "escalation_level_two",
      headerName: "Escalation-2",
      flex: 1,
      headerAlign: "center",
      valueGetter: (params) => params.value.user_name,
    },
    {
      field: "escalation_level_three",
      headerName: "Escalation-3",
      flex: 1,
      headerAlign: "center",
      valueGetter: (params) => params.value.user_name,
    },
    {
      field: "created_by",
      headerName: "Created By",
      flex: 1,
      headerAlign: "center",
      valueGetter: (params) => params?.value ?? "-",
    },
    {
      field: "updated_by",
      headerName: "Last Modified By",
      flex: 1,
      headerAlign: "center",
      valueGetter: (params) => params?.value ?? "-",
    },
    {
      field: "addedDateAndTime",
      headerName: "Created On",
      flex: 1,
      headerAlign: "center",
      valueFormatter: (params) => {
        return customDateFormat(params.value);
      },
    },
    {
      field: "updatedDateAndTime",
      headerName: "Updated On",
      flex: 1,
      headerAlign: "center",
      valueFormatter: (params) => {
        return customDateFormat(params.value);
      },
    },
    ...(userData?.role !== "CC Processor"
      ? [
        {
          field: "actions",
          type: "actions",
          headerName: "Actions",
          flex: 0.8,
          cellClassName: "actions",
          getActions: ({ row }) => {
            let actionsList = [];
            if (UserAuthorisation?.["Edit"] === "Y") {
              actionsList.push(
                <GridActionsCellItem
                  icon={
                    <Tooltip title="Edit">
                      {" "}
                      <EditIcon />{" "}
                    </Tooltip>
                  }
                  label="Edit"
                  className="textPrimary"
                  onClick={() => handleActionButton(row, true)}
                  color="inherit"
                />
              );
            }
            // if (UserAuthorisation?.['Delete'] === "Y") {
            //   actionsList.push(
            //     <GridActionsCellItem
            //       icon={<Tooltip title="Delete"><DeleteIcon /> </Tooltip>}
            //       label="Delete"
            //       onClick={() => handleDeleteClick(row.id)}
            //       color="inherit"
            //     />
            //   );
            // }
            if (UserAuthorisation?.["View"] === "Y") {
              actionsList.push(
                <GridActionsCellItem
                  icon={<VisibilityIcon />}
                  label="view"
                  className="textPrimary"
                  onClick={() => handleActionButton(row, false)}
                  color="inherit"
                />
              );
            }
            return actionsList;
          },
        },
      ]
      : [
        {
          field: "actions",
          type: "actions",
          headerName: "Actions",
          flex: 0.8,
          cellClassName: "actions",
          getActions: ({ row }) => {
            let actionsList = [];
    
            // if (UserAuthorisation?.['View'] === "Y") {
              actionsList.push(
                <GridActionsCellItem
                  icon={<VisibilityIcon />}
                  label="view"
                  className="textPrimary"
                  onClick={() => handleActionButton(row, false)}
                  color="inherit"
                />
              );
            // }
    
            return actionsList;
          },
        }
      ]),
  ];

  const loadData = async () => {
    try {
      setIsApiCallInprogress(true);
      const resp = await instance.get(Escalation);
      setIsApiCallInprogress(false);
      if (resp.status === 200) {
        // const sortedData = resp.data.sort((a, b) => b.id - a.id);
        setTableRows(resp.data);
      } else {
        setTableRows([]);
      }
    } catch (err) {
      setIsApiCallInprogress(false);
      console.error("err", err);
    }
  };

  const UserAuthorisation =
    userData?.user_permissions?.permissions_list["Admin Table Maintenance"];

  useEffect(() => {
    loadData();
  }, []);

  const handleInputChange = (colName, value) => {
    const updatedRow = { ...row };

    updatedRow[colName] = value;
    setRow(updatedRow);

    if (colName === "transaction_type") {
      if (value === "Bank Transaction") {
        setStatuses(bankTransactionStatuses);
      } else {
        setStatuses(cashAllocationStatuses);
      }
    }

    // Edit Mode
    if (editMode) {
      setCurrentUpdatedFiledsInEditMode({
        ...currentUpdatedFiledsInEditMode,
        [colName]: value,
      });
    }
  };
  const validateRow = (row) => {
    const fieldValidations = {};

    // Perform your validations here, for example:
    if (!row || !row.organization || row.organization.trim() === "") {
      fieldValidations.organization = "This field is required";
    }
    if (!row || !row.transaction_type || row.transaction_type.trim() === "") {
      fieldValidations.transaction_type = "This field is required";
    }
    if (!row || !row.status || row.status.length === 0) {
      fieldValidations.status = "This field is required";
    }
    if (!row || !row.escalation_level_one || !row.escalation_level_one.id) {
      fieldValidations.escalation_level_one = "This field is required";
    }

    if (!row || !row.escalation_level_two || !row.escalation_level_two.id) {
      fieldValidations.escalation_level_two = "This field is required";
    }
    if (!row || !row.escalation_level_three || !row.escalation_level_three.id) {
      fieldValidations.escalation_level_three = "This field is required";
    }
    // Add more validations for other fields...

    setValidationStatus((prevStatus) => {
      const newStatus = fieldValidations;
      return newStatus;
    });

    return Object.keys(fieldValidations).length === 0;
  };

  const handleSubmit = async () => {
    setIsDisable(true);
    // Validate row before submission
    const isRowValid = validateRow(row);

    let editModeObj = {};
    if (editMode) {
      editModeObj.id = editRow?.id;
      editModeObj["updated_by"] = userData?.user_name ?? "";
      editModeObj = { ...editModeObj, ...currentUpdatedFiledsInEditMode };
    }

    if (!isRowValid) {
      // If row is invalid, stop the submission and display an error
      commonToast("error", "Please fill all required fields.");
      setIsDisable(false);
      return;
    }

    try {
      let response;
      if (editMode) {
        response = await instance.patch(Escalation + editId + "/", editModeObj);
        // clear preiously updated stored data
        setCurrentUpdatedFiledsInEditMode({});
      } else {
        const payload = {
          ...row,
          escalation_level_one: row.escalation_level_one.id,
          escalation_level_two: row.escalation_level_two.id,
          escalation_level_three: row.escalation_level_three.id,
        };
        payload.created_by = userData?.user_name ?? "";

        response = await instance.post(Escalation, payload);
      }

      if (response) {
        if (editMode) {
          commonToast("success", "Updated successfully !");
        } else {
          commonToast("success", "Submission successful !");
        }

        // clean up
        cleanupTransactionData();
      }
    } catch (err) {
      commonToast("error", "Submission failed. Please try again.");
    } finally {
      setIsDisable(false);
    }
  };

  const cleanupTransactionData = () => {
    handleDialogClose();
    loadData();
  };

  const handleDownloadBtnClick = () => {
    setIsDownloadInProgress(true);
    try {
      instance
        .get(`${downloadEscalation}`, { responseType: "blob" })
        .then((response) => {
          const url = URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = url;
          const fileName = `Escalation_${format(new Date(), "dd-MM-yyyy")}`
          link.setAttribute("download", `${fileName}.xlsx`);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          setIsDownloadInProgress(false);
          commonToast("success", "Escalation data has been downloaded successfully");
        }).catch((err) => {
          console.log(err);
          setIsDownloadInProgress(false);
          commonToast("error", "Escalation data could not be downloaded");
        });
    } catch (error) {
      setIsDownloadInProgress(false);
      console.log(error);
      commonToast("error", "Escalation data could not be downloaded");
    }
  }

  return (
    <div style={Container}>
      <div style={AssignBankStatementBar}>
        <span style={{ color: "#FF5A01", fontSize: "24px" }}>Escalation</span>
        <div style={{ display: "flex", marginRight: "10px" }}>
          {UserAuthorisation?.["Creation"] === "Y" && (
            <>
              <CommonButton
                text="Add"
                handleClick={() => handleActionButton()}
                sx={bankTransactionAddBtn}
                hoverColor="#FF5A01"
              />
              <CommonButton
                text="Export"
                handleClick={handleDownloadBtnClick}
                sx={downloadBtn}
                hoverColor="#FF5A01"
                disabled={isDownloadInProgress}
              />
            </>
          )}
        </div>
      </div>

      <div
        style={{
          height: "calc(100vh - 230px)",
          position: "relative",
          display: "flex",
          flexDirection: "row-reverse",
        }}
      >
        <DataGrid
          loading={isApiCallInprogress}
          rows={tableRows}
          columns={columns}
          // pageSize={pageSize}
          rowCount={tableRows?.length}
          pagination={false}
          paginationMode="server"
          hideFooterPagination
          hideFooter
          // onPageChange={(newPage) => {
          //   setPage(newPage);
          // }}
          // paginationMode="server"
          // onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          showCellRightBorder={true}
          rowHeight={38}
        // checkboxSelection
        // onSelectionModelChange={(id) => {
        //   setArrToBeDeleted(id);
        // }}
        />
      </div>
      <Dialog
        open={escalationDialog}
        disableBackdropClick
        disableEscapeKeyDown
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        PaperProps={!viewMode && !editMode && { style: dialogStyle } || {}}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ cursor: "default", paddingBottom: "0px" }}
        >
          {viewMode
            ? "View Escalation"
            : editMode
              ? "Edit Escalation"
              : "Add Escalation"}
          <IconButton
            aria-label="close"
            onClick={handleDialogClose}
            style={{ position: "absolute", right: 12, top: 12 }}
          >
            <CloseIcon style={CloseIconStyle} />
          </IconButton>
          <hr style={{ width: "100%" }} />
        </DialogTitle>
        <DialogContent
          sx={{ overflowX: "hidden", padding: "0px 24px 5px 24px" }}
        >
          <div elevation={4} style={EditPageContainerTransactions}>
            {isCreated ? (
              <TableContainer style={{ maxHeight: "300px" }}>
                <AddEscalation
                  handleInputChange={handleInputChange}
                  row={row}
                  validationStatus={validationStatus}
                  statuses={statuses}
                  handleEscalationUserChange={handleEscalationUserChange}
                  usersList={usersList}
                />
              </TableContainer>
            ) : (
              <>
                <Grid display={"flex"} flexDirection={"column"}>
                  <ViewAndEditEntity
                    row={row}
                    viewMode={viewMode}
                    validationStatus={validationStatus}
                    editMode={editMode}
                    handleInputChange={handleInputChange}
                    statuses={statuses}
                    handleEscalationUserChange={handleEscalationUserChange}
                    usersList={usersList}
                  />
                </Grid>
              </>
            )}
          </div>
        </DialogContent>

        <DialogActions style={ResetSubmit}>
          {viewMode ? null : (
            <>
              {isCreated && (
                <CommonButton
                  sx={addBankTransactionReset}
                  text="Reset"
                  handleClick={() => handleReset()}
                  disabled={editMode}
                />
              )}
              {editMode && (
                <CommonButton
                  sx={editEntityUpdate}
                  text="Update"
                  handleClick={handleSubmit}
                  disabled={
                    Object.keys(currentUpdatedFiledsInEditMode)?.length <= 0
                  || isDisable}
                  hoverColor="#FF5A01"
                />
              )}
              {!editMode && !viewMode && (
                <CommonButton
                  sx={addBankTransactionSubmit}
                  text="Submit"
                  handleClick={handleSubmit}
                  hoverColor="#FF5A01"
                  disabled={isDisable}
                />
              )}
            </>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
}
